import { PaymentType } from '../enums/payment-type.enum'

export const subscriptionMapper = {
  [PaymentType.BOLETO]: 'Boleto',
  [PaymentType.CREDIT]: 'Cartão de crédito',
  [PaymentType.DEBIT]: 'Cartão de débito',
}
